import React from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const BarCodeScan = () => {
    return(
        <div id="barcode">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Having Trouble Scanning Barcodes?</h2>
                        <p>All Hardware should be pre-configured before it enters your store, but OS updates and hardware swaps can cause the functionallity to change.</p>
                        <p>Follow the steps below to configure your barcode scanner to the prefered TechPOS settings</p>
                        <ol>
                            <li>Scan this code to start configuration</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/BarCode/start.png" />
                            <li>Scan this code to bring scanner to compliant setting</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/BarCode/stxetx.png" />
                            <li>Scan this code to end configuartion</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/BarCode/end.png" />
                            <li>Scan this code to save configuration</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/BarCode/save.png" />
                        </ol>
                        <p>NOTE: If you continue to encounter scanner problems, please contact customer support</p>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default BarCodeScan;